'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Gymnastics = function (_PureComponent) {
  (0, _inherits3.default)(Gymnastics, _PureComponent);
  function Gymnastics() {
    (0, _classCallCheck3.default)(this, Gymnastics);
    return (0, _possibleConstructorReturn3.default)(this, (Gymnastics.__proto__ || (0, _getPrototypeOf2.default)(Gymnastics)).apply(this, arguments));
  }
  (0, _createClass3.default)(Gymnastics, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 25 32',
        style: {
          width: '0.78125em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M19.162 17.462V1.076a1.076 1.076 0 0 0-2.152 0v16.386a7.253 7.253 0 0 0-3.302 1.376 6.876 6.876 0 0 0-5.748-5.94V1.076a1.076 1.076 0 0 0-2.152 0v11.822C2.518 13.416 0 16.254 0 19.688a6.884 6.884 0 0 0 6.884 6.884 6.848 6.848 0 0 0 3.922-1.23A7.31 7.31 0 0 0 18.086 32a7.313 7.313 0 0 0 7.314-7.314c0-3.672-2.71-6.704-6.238-7.224zM6.884 23.946a4.258 4.258 0 1 1 0-8.513 4.258 4.258 0 0 1 0 8.513zm11.202 5.264a4.522 4.522 0 0 1-4.522-4.524c0-2.498 2.024-4.522 4.522-4.522s4.524 2.026 4.524 4.522a4.526 4.526 0 0 1-4.524 4.524z'
      }));
    }
  }]);
  return Gymnastics;
}(_react.PureComponent);
Gymnastics.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Gymnastics;